module.exports = __webpack_public_path__ + "static/WA-25d8ccf2b2508490bcf10a0e16056795.svg";